import { Col, Input, Label } from "reactstrap";
import { FilledCheckbox, WarningCheckboxSolidWarning } from "../../../../Constant";
import { FILL_CHECKBOX_LIST } from "../../../../Data/FormControl/CheckboxAndRadio";
import { H6 } from "../../../../AbstractElements";

export const FilledCheckboxs = () => {
  return (
    <Col xl="4" sm="6">
      <div className="card-wrapper border rounded-3 h-100 checkbox-checked">
        <H6 className="sub-title">{FilledCheckbox}</H6>
        <div className="form-check checkbox checkbox-solid-warning">
          <Input id="solid4" type="checkbox" defaultChecked />
          <Label className="form-check-label" htmlFor="solid4" check>
            {WarningCheckboxSolidWarning}
          </Label>
        </div>
        {FILL_CHECKBOX_LIST.map(({ id, text, color }, index) => (
          <div className={`form-check checkbox checkbox-solid-${color}`} key={index}>
            <Input id={`solid-${id}`} type="checkbox" />
            <Label className="form-check-label" htmlFor={`solid-${id}`} check>
              {text}
            </Label>
          </div>
        ))}
      </div>
    </Col>
  );
};
